import { atom } from 'recoil';
import type { RecoilState } from 'recoil';
import type { StatefulSplitClient } from './StatefulSplitClient';

type SplitIoState = {
  client: StatefulSplitClient | null;
  ready: boolean;
  timeout: boolean;
  email: string;
};

export const splitIoState: RecoilState<SplitIoState> = atom<SplitIoState>({
  key: 'splitio',
  default: { client: null, ready: false, timeout: false, email: '' },
  dangerouslyAllowMutability: true,
});
